/**
 * @deprecated Use useFeatureFlag hook instead.
 */
export const isFeatureEnabled = (user, flag) => {
    return user && user.featureFlags.includes(flag)
};

export const FeatureFlags = {
    DiscountAgreements: "Discount_Agreements",
    VOSS_2308_Invoicing: "Voss_Invoicing",
    VOSS_2308_Invoicing_TransactionSource: "Voss_Invoicing_TransactionSource",
    VSCO_2308_Future_dates: "Voss_Invoicing_Future_dates",
    VOSSViewInvoice: "VOSS_View_Invoice",
    VOSSCompensationsTest: "VOSS_Compensations_Test",
    VSCO_3081_GDPR_USER_INTERFACE: "VSCO_3081_GDPR_USER_INTERFACE",
    Survicate: "Survicate"
};